import React from 'react';
import { useSelector } from 'react-redux';
import { checkCustomPackage, checkFreePackage } from '@src/services/package';
import Text from '../Shared/Text';
import CheckOrCross from '../Shared/CheckOrCross';

const ConcurrentAPIRequestsFeature = ({ pkg }) => {
  const optionsSelected = useSelector(
    (state) => state.packages.optionsSelected,
  );

  const isCustomPackage = checkCustomPackage({
    type: pkg.type,
    level: pkg.level,
  });
  if (checkFreePackage(pkg?.code)) {
    return <CheckOrCross key={pkg.code} isCheck={false} />;
  }
  if (isCustomPackage) {
    const minAPIRequests = pkg?.customResource?.concurrentRequestApi?.min || 0;
    const totalAPIRequests =
      minAPIRequests + optionsSelected?.concurrentRequestApi || 0;
    return <Text key={pkg.code} text={totalAPIRequests} />;
  }

  return <Text key={pkg.code} text={pkg?.concurrentRequestApi} />;
};

const concurrentAPIRequestsFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <ConcurrentAPIRequestsFeature key={pkg.code} pkg={pkg} />
  ));

export default concurrentAPIRequestsFeatures;
